module.exports = __webpack_public_path__ + "img/dots_rub_4.fb37e0a6.png";